import { onClickPay, ServiceSubCategory, serviceType } from '@/commonTypes';
import PageCard from '@/components/general/PageCard';
import MainIcons from '@/icons/main';
import React from 'react';
import styles from '../../styles.module.css';
import { avatarBg } from '@/functions/formats';
import NoneViolationDetails from '@/components/pages/plates/MyPlatesContent/MyPlatesList/DropDownPlateCard/PlateDetails/NonViolationDetails';
import ConfirmationButton from '@/components/common/ConfirmationButton';
import LivePill from '../LivePill';
import MyPlatesTotal from '@/components/pages/plates/MyPlatesContent/MyPlatesTotal';
import Button from '@/components/common/Button';
import { subCategoryIdList } from '@/api/global';

export default function ServiceResult({
  data,
  type,
  onClickPay,
  callBackHistory,
  subCategoryInfo,
}: {
  data?: ServiceSubCategory;
  type?: string;
  onClickPay?: onClickPay;
  callBackHistory?: any;
  subCategoryInfo?: ServiceSubCategory;
}) {
  const d = {
    label: 'مبلغ قابل پرداخت',
    value: data?.response?.price,
    showDiscount: false,
  };
  console.log('hhhhhhhhhhhh====', data, subCategoryIdList?.vehicle_violations_summary);
  return (
    <>
      <PageCard
        // title="وضعیت و امتیازات  "
        title={subCategoryInfo?.title}
        text="به‌روزرسانی لحظه‌ای"
        icon={<MainIcons.flashIcon width="20px" height="20px" fill="var(--paper)" />}
        backgroundIcon={avatarBg(1)}
        className={`${styles.pageCard}`}
        aside={<LivePill />}
      >
        {data?.response && <NoneViolationDetails response={data?.response} type={type} />}
      </PageCard>
      {data?.service_key == subCategoryIdList?.vehicle_violations_summary && (
        <MyPlatesTotal d={d} className={`${styles.pageCard} mt-18px`}>
          <Button
            className={`btn btn-primary squareButton noBoxShadow`}
            onClick={() => {
              onClickPay &&
                onClickPay(
                  'pay',
                  { ...data, price: data?.response?.price, history_id: data?.id },
                  callBackHistory,
                );
            }}
          >
            <MainIcons.LockIcon fill="var(--paper)" width="17px" height="17px" />
            پرداخت تجمیع تخلفات خودرو
          </Button>
        </MyPlatesTotal>
      )}
      {/* <ConfirmationButton
        className={`${styles.pageCard} ${styles.footerButtonContainer}`}
        confirmText={
          <>
            <MainIcons.clockIcon fill="var(--brand-deep)" width="18px" height="18px" />
            {'مشاهده خلافی‌ها'}
          </>
        }
        extraConfirmStyle={`${styles.footerButton}  btn-white`}
        extraRejectStyle={`${styles.footerButton}`}
        rejectText={
          <>
            <MainIcons.plusIcon fill="#fff" width="18px" height="18px" />
            {' افزودن پلاک جدید'}
          </>
        }
      /> */}
    </>
  );
}
